import { SectionsAnalyticsPage } from "../SectionsAnalyticsPage/index";

const SectionAnalyticsAmountPage = () => (
  <SectionsAnalyticsPage analyticsType="amount" />
);

export default SectionAnalyticsAmountPage;
